/*
* @Author: zhangzhitao
* @Date: 2019-06-20 12:13:25
* @Des:
 * @Last Modified by: zhangzhitao
 * @Last Modified time: 2019-07-31 19:51:01
*/

<template>
  <div class="m-linkage-nav-outer">
    <!-- :router="true" -->
    <el-menu
      @mouseenter.native="handleMenuMouseEnter"
      @mouseleave.native="handleMenuMouseLeave"
      mode="horizontal"
      @open="handleMenuOpen"
      @close="handleMenuClose"
      @select="onMenuSelect"
      ref="menu"
      theme="dark"
    >
      <MenuItem
        v-for="menu in menusMore"
        :menu="menu"
        :key="menu.id"
      >
      </MenuItem>
    </el-menu>
  </div>
</template>

<script>
import MenuItem from './menu-item'
import { mapMutations, mapGetters } from 'vuex'
import { on, off } from '@hui-pro/utils'
export default {
  name: 'horizontal-menu',
  props: {
    menus: {
      type: Array,
      default () {
        return []
      }
    },
    sysInfoWidth: {
      type: Number,
      default: 0
    },
    activeWrapType: {
      type: String,
      default: 'home'
    }
  },
  data () {
    return {
      activePath: this.$storage.session.get(`portal-active-tab-menu-${this.$store.state.userName}`) || 'home',
      winW: 0
    }
  },
  components: { MenuItem },
  computed: {
    ...mapGetters(['activeTabMenu']),
    menusMore () {
      let winW = this.winW
      if (winW < 1280) winW = 1280
      // 减去logo+系统名称+toolBar（导航工具栏）宽度，即为菜单宽度。730为限制最大宽度
      let menuCtnW = winW - 440 - this.sysInfoWidth - 40
      let _tempWidth = 0
      let _i = 0
      for (let i = 0; i < this.menus.length; i++) {
        let item = this.menus[i].name
        let itemWidth = item.length * 16 + 80
        _tempWidth += itemWidth > 240 ? 240 : itemWidth
        _i = i
        if (_tempWidth > menuCtnW) {
          break
        }
      }
      let _menus = _i === this.menus.length - 1 ? this.menus : this.menus.slice(0, _i)
      if (this.menus.length - _i - 1 > 0) {
        let _menuMore = {
          id: 'hikvision_more_menu',
          name: this.$t('common.more'),
          menuId: 'more',
          children: []
        }
        for (let j = _i; j < this.menus.length; j++) {
          _menuMore.children.push(this.menus[j])
        }
        _menus.push(_menuMore)
      }
      return _menus
    }
  },
  mounted () {
    this.initActiveMenu()
    this.handleWindowWidth()
    on(window, 'resize', this.handleWindowWidth)
  },
  methods: {
    handleWindowWidth () {
      this.winW = document.getElementsByTagName('body')[0].offsetWidth
    },
    // 鼠标离开菜单
    handleMenuMouseLeave () {
      let params = {
        mouseType: 'leave',
        servFlag: 'tipSize'
      }
      let targetFrame =
        document.getElementById(`iframe${this.$store.state.activeTabMenu}`) ||
        document.getElementById('iseframe')
      if (targetFrame) {
        targetFrame.contentWindow.postMessage(JSON.stringify(params), '*')
      }
    },
    // 鼠标进入菜单
    handleMenuMouseEnter () {
      let params = {
        mouseType: 'enter',
        servFlag: 'tipSize'
      }
      let targetFrame =
        document.getElementById(`iframe${this.$store.state.activeTabMenu}`) ||
        document.getElementById('iseframe')
      if (targetFrame) {
        targetFrame.contentWindow.postMessage(JSON.stringify(params), '*')
      }
    },
    handleMenuOpen (index) {
      this.coverVideo(index)
    },
    handleMenuClose (index) {
      this.coverVideo(index)
    },
    coverVideo (index) {
      let targetFrame =
        document.getElementById(`iframe${this.$store.state.activeTabMenu}`) ||
        document.getElementById('iseframe')
      let dropDom = document.getElementsByName(`cover_${index}`)[0].childNodes[1]
      setTimeout(() => {
        let argus = ''
        let msg
        if (dropDom) {
          let _dom = dropDom.getBoundingClientRect()
          // 发给1903视频控件
          argus = {
            servFlag: 'tipSize',
            data: {
              left: _dom.left,
              right: _dom.right,
              top: _dom.top,
              bottom: _dom.bottom,
              width: _dom.width,
              height: _dom.height
            }
          }
          msg = {
            method: 'showContentOverTool',
            argument: {
              isExtend: _dom.width > 0 && _dom.height > 0, // true表示需要切割控件
              target: `cover_${index}`, // 考虑到控件上可能需要显示不止一块内容，故给每个下拉框等dom设置了一个名称
              pos: {
                left: _dom.left,
                right: _dom.right,
                top: _dom.top,
                bottom: _dom.bottom,
                width: _dom.width,
                height: _dom.height
              }
            }
          }
        }
        let data = JSON.stringify(argus)
        if (targetFrame) {
          targetFrame.contentWindow.postMessage(JSON.stringify(msg), '*')
          targetFrame.contentWindow.postMessage(data, '*')
        }
      }, 500)
    },
    ...mapMutations({
      setActiveTabMenu: 'SET_ACTIVE_TAB_MENU',
      setViewType: 'SET_VIEW_TYPE'
    }),
    onMenuSelect (menuId) {
      let viewType = menuId === 'home' ? 'home' : 'view'
      this.setViewType(viewType)
      this.$storage.session.set(`viewType-${this.$store.state.userName}`, viewType)
      let menu = this.findMenu(this.menus, menuId, 'menuId')
      if (menu.openType === 2) {
        window.open(menu.fullUrl)
      } else {
        let params = {
          menuId: menu.menuId,
          componentMenuId: menu.componentMenuId || null,
          permissionCode: menu.permissionCode || null
        }
        this.setActiveTabMenu(params)
      }
    },
    findMenu (arr, value, key) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i][key] === value) {
          return arr[i]
        }
        if (arr[i]._hasChild || (arr[i].children && arr[i].children.length > 0)) {
          let _res = this.findMenu(arr[i].children, value, key)
          if (_res) return _res
        }
      }
      return null
    },
    initActiveMenu () {
      this.$refs.menu.activeIndex = this.activeTabMenu
    }
  },
  watch: {
    activeTabMenu (menuId) {
      let viewType = menuId === 'home' ? 'home' : 'view'
      this.setViewType(viewType)
      this.activePath = menuId
      this.initActiveMenu()
    }
  },
  beforeDestroy () {
    off(window, 'resize', this.handleWindowWidth)
  }
}

</script>

<style lang="scss" scoped>
.m-linkage-nav-outer {
  ::v-deep > .el-menu {
    .el-submenu > .el-menu {
      min-width: 200px;
    }
    background-color: transparent;
    .el-menu-item {
      max-width: 240px;
      color: rgba(255, 255, 255, 0.7);
    }
    .el-submenu {
      max-width: 240px;
      .el-submenu {
        .el-submenu__title--text {
          display: inline-block;
          width: calc(100% - 32px);
          top: -3px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .el-submenu__title--text {
        color: rgba(255, 255, 255, 0.7);
      }
    }
    > .el-menu-item:hover,
    > .el-submenu__title:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    > .el-submenu.is-opened {
      background: rgba(255, 255, 255, 0.1);
      > .el-submenu__title:hover {
        background: rgba(255, 255, 255, 0.1);
      }
      > .el-menu {
        top: 60px;
      }
      .el-submenu {
        .el-submenu__title > i {
          transform: rotate(-90deg) !important;
        }
        &.is-opened {
          > .el-submenu__title > i {
            transform: rotate(90deg) !important;
          }
        }
      }
    }
    .el-menu-item {
      &.is-active {
        background: rgba(255, 255, 255, 0.2) !important;
        border: none;
        color: #fff !important;
      }
    }
    > .el-submenu > .el-submenu__title {
      min-width: 110px;
      text-align: center;
    }
    > .el-menu-item {
      text-align: center;
      min-width: 110px;
    }
    .el-submenu {
      &.is-active {
        > .el-submenu__title {
          > .el-submenu__title--text {
            color: #fff !important;
          }
        }
        background: rgba(255, 255, 255, 0.2) !important;
        .el-submenu__title {
          color: #fff !important;
          border: none;
        }
      }
      i {
        color: rgba(255, 255, 255, 0.7) !important;
      }
      &:hover {
        i {
          color: rgba(255, 255, 255, 0.7) !important;
        }
      }
    }

    // 下拉子菜单
    .el-menu {
      background-color: #3a3a3a;
      border-radius: 2px;
      border: none;
      .el-submenu {
        background: none;
        .el-submenu__title {
          background: none;
        }
      }
      .el-menu-item {
        background: none;
        &:hover {
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }
  }
}
</style>
